import axios from "axios";

const api = axios.create({
  baseURL: 'https://skylandinvest.com/api',
});

export default api;
